import { render, staticRenderFns } from "./BizgainStatusLayout.vue?vue&type=template&id=0e649e00&scoped=true&"
import script from "./BizgainStatusLayout.vue?vue&type=script&lang=js&"
export * from "./BizgainStatusLayout.vue?vue&type=script&lang=js&"
import style0 from "./BizgainStatusLayout.vue?vue&type=style&index=0&id=0e649e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e649e00",
  null
  
)

export default component.exports